import React from "react";
import styles from "./Footer.module.scss";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <span>© 2022 Nurline Solutions Pvt Ltd.</span>
    </footer>
  );
};

export default Footer;
